import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import http from './http'

export function add(
	patientIds: string[],
	text: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `/p/note`,
		data: {
			note: {
				title: '',
				body: text,
				patientSatisfaction: null,
			},
			patientIds: patientIds,
		},
	})
}
